var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.198,
    height: 37.198,
    viewBox: "0 0 37.198 37.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(-344 -41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93487",
    "data-name": "Path 93487",
    d: "M14.879,0h7.44A14.879,14.879,0,0,1,37.2,14.879v7.44A14.879,14.879,0,0,1,22.319,37.2h-7.44A14.879,14.879,0,0,1,0,22.319v-7.44A14.879,14.879,0,0,1,14.879,0Z",
    transform: "translate(344 41)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(355.16 55.879)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 15.242,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 15.242,
    transform: "translate(0 4.464)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93488",
    "data-name": "Path 93488",
    d: "M0,0H15.242",
    transform: "translate(0 8.184)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/HamburgerIcon.91411fed566a6d39785dde3fd59145f9.svg";
export { ForwardRef as ReactComponent };